import { render, staticRenderFns } from "./ActComments.vue?vue&type=template&id=83278096"
import script from "./ActComments.vue?vue&type=script&lang=js"
export * from "./ActComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports